import { Link } from 'react-router-dom';
import { formatPrice, calculatePerPersonCost, isWorkstationProduct } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';

export const ProductCard = ({ product, featured = false }) => {
  const { addToCart } = useCart();
  
  // Use slug-based URL if available, fallback to ID
  const productUrl = product.slug ? `/product/${product.slug}` : `/products/${product.id}`;

  const handleAddToCart = (e) => {
    e.preventDefault();
    addToCart(product, 1);
    toast.success(`${product.name} added to cart!`);
  };

  return (
    <Link
      to={productUrl}
      className="group block border-2 border-border hover:border-primary transition-all duration-300 overflow-hidden bg-card"
      data-testid="product-card"
    >
      <div className="relative overflow-hidden">
        <img
          src={product.image_url}
          alt={`${product.name} - ${product.subcategory || product.category} - Buy Online at Modular Furniture Store`}
          className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
          width={400}
          height={256}
        />
        <div className="absolute top-4 right-4 bg-primary text-primary-foreground px-3 py-1 text-xs font-bold uppercase tracking-wider">
          {product.category === "Modular Office Workstation"
            ? "WORKSTATION"
            : product.category === "Storage Cabinets"
            ? "STORAGE"
            : "PRIVACY"}
        </div>
      </div>

      <div className="p-6">
        <div className="mb-4">
          <h3 className="text-xl font-black uppercase mb-2 group-hover:text-primary transition-colors">
            {product.name}
          </h3>
          <p className="text-sm text-muted-foreground uppercase tracking-wider">
            {product.subcategory}
          </p>
        </div>

        {product.dimensions && typeof product.dimensions === 'string' && (
          <p className="mono text-xs text-muted-foreground mb-4">
            {product.dimensions}
          </p>
        )}

        <div className="mb-4">
          {product.mrp && (
            <div className="flex items-center gap-3 mb-2">
              <span className="text-sm text-muted-foreground line-through">
                MRP {formatPrice(product.mrp)}
              </span>
              {product.discount_percent && (
                <span className="bg-accent text-accent-foreground px-2 py-1 text-xs font-bold uppercase">
                  {product.discount_percent}% OFF
                </span>
              )}
            </div>
          )}
          
          <p className="mono text-2xl font-black text-primary mb-1">
            {formatPrice(product.price)}
          </p>
          <p className="text-xs text-green-600 font-medium mb-2">
            🚚 Free Shipping within Mumbai & Navi Mumbai
          </p>
          
          {isWorkstationProduct(product.category) && (
            <div className="bg-accent border-2 border-accent rounded-none p-3">
              <p className="text-xs font-bold mb-1 text-accent-foreground">PER PERSON</p>
              <p className="mono text-xl font-black text-primary">
                {formatPrice(calculatePerPersonCost(product.price, product.subcategory))}
              </p>
            </div>
          )}
        </div>

        <Button
          onClick={handleAddToCart}
          data-testid={`add-to-cart-${product.id}`}
          className="w-full bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground rounded-none uppercase tracking-wider font-bold py-4 transition-all duration-300"
        >
          ADD TO CART
        </Button>
      </div>
    </Link>
  );
};
